<template>
  <div :class="['sj-menu', theme]" :style="{ maxHeight }">
    <template v-for="(item, index) in data">
      <SjDropdown
        placement="right-start"
        :key="item.key"
        :disabled="item.disabled"
        customStyle
        :arrowVisible="false"
        v-if="item.children && item.children.length > 0"
        @show="selectedMenu = item.key"
        @hide="selectedMenu = null"
        trigger="hover"
        :boundariesSelector="boundariesSelector"
      >
        <div
          @click.stop
          class="sj-menu-item"
          slot="reference"
          :class="{
            first: index === 0,
            last: index === data.length - 1,
            disabled: item.disabled,
            menuSelected: selectedMenu === item.key,
            selected: checkSelected(item.key)
          }"
        >
          <div class="left">
            {{ item.label }}
          </div>
          <div class="right">
            <i class="icon_com compagi_next" />
          </div>
        </div>
        <SjMenu
          slot="dropdown"
          :theme="theme"
          :data="item.children"
          @select="$emit('select', $event)"
          :max-height="item.maxHeight"
          :boundariesSelector="boundariesSelector"
          :selected-key="selectedKey"
        />
      </SjDropdown>
      <div
        class="sj-menu-item"
        v-else
        :class="{
          disabled: item.disabled,
          first: index === 0,
          last: index === data.length - 1,
          selected: checkSelected(item.key)
        }"
        :key="item.key"
        @click="handleItemClick(item)"
      >
        <div class="left">
          {{ item.label }}
        </div>
        <div class="right" v-if="item.extra">
          {{ item.extra }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/**
 * card组件，为一个可自定义内容的显示区域，无额外功能。
 */
export default {
  name: "SjMenu",
  props: {
    theme: {
      type: String,
      default: "available" // highlight shadow
    },
    data: Array,
    boundariesSelector: {
      type: String,
      default: "body"
    },
    maxHeight: {
      type: String,
      default: "auto"
    },
    selectedKey: {
      type: null
    }
  },
  data() {
    return {
      selectedMenu: null
    };
  },
  methods: {
    checkSelected(key) {
      if (Array.isArray(this.selectedKey)) {
        return this.selectedKey.includes(key);
      } else {
        return this.selectedKey === key;
      }
    },
    handleItemClick(item) {
      if (item.disabled) return;
      this.$emit("select", item.key);
    }
  }
};
</script>

<style lang="less" scoped>
.sj-menu {
  border-radius: @base-border-radius;
  background-color: @color-antibg;
  min-width: 120px;
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  overflow: auto;
  /*overflow: hidden;*/

  &.available {
    border: 1px solid @color-available;
    /deep/ .sj-menu-item {
      .text("caption", "available");
    }
  }
  &.highlight {
    border: 1px solid @color-highlight;
    /deep/ .sj-menu-item {
      .text("caption", "highlight");
    }
  }

  &.shadow {
    box-shadow: 0 4px 6px 0 rgba(144, 164, 183, 0.22);
    /deep/ .sj-menu-item {
      .text("caption", "available");
    }
  }

  /deep/ .sj-menu-item {
    padding: 6px 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &.first {
      border-radius: @base-border-radius @base-border-radius 0 0;
    }
    &.last {
      border-radius: 0 0 @base-border-radius @base-border-radius;
    }

    .left {
      flex-grow: 1;
      min-width: 0;
      word-break: keep-all;
      /*margin-left: 9px;*/
    }
    .right {
      margin-left: 50px;
      /*margin-right: 9px;*/
      flex-shrink: 0;
      i {
        font-size: 16px;
      }
    }

    &.disabled {
      color: @color-light;
      cursor: not-allowed;
    }

    &:not(.disabled) {
      cursor: pointer;

      &.selected {
        background-color: @color-gray-3;
      }

      &:hover,
      &.menuSelected {
        background-color: @color-gray-2;
      }
    }
  }
}
</style>
